import extend from 'extend'
import Theme from '../core/theme'

let documentScope = document
const kioskContainer = document.querySelector('#kiosk-container')

if (kioskContainer) {
  documentScope = kioskContainer.contentDocument
}

class BaseTheme extends Theme {
  constructor(quill, options) {
    super(quill, options)
    let listener = () => {
      if (!documentScope.body.contains(quill.root)) {
        return documentScope.body.removeEventListener('click', listener)
      }
    }
    quill.emitter.listenDOM('click', documentScope.body, listener)
  }

  addModule(name) {
    let module = super.addModule(name)
    if (name === 'toolbar') {
      this.extendToolbar(module)
    }
    return module
  }
}
BaseTheme.DEFAULTS = extend(true, {}, Theme.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {},
    },
  },
})

export default BaseTheme
